import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NeqTableRequest } from "@sharedcommon/components/table/neq-table-request.model";
import { NeqTableData } from "@sharedcommon/model/neq-table-data.model";
import { EntityRightFilterDto, EntityServiceClient, RawMaterialDto, RawMaterialFilterDto, RawMaterialNutrientDto, RawMaterialNutrientSaveDto, RawMaterialSaveDto, RawMaterialService, ReferenceFilterDto, SubReferenceRightServiceClient } from "@sharedcommon/rest/data.restservice";
import { UserService } from "@sharedcommon/services/user.service";
import { PrimengTableCols } from "@sharedcommon/interfaces/primeng-table-cols";
import { ActivatedRoute, Router } from "@angular/router";
import { RawMaterialsMultiEditService } from "@usercommon/service/rawmaterials-multi-edit.service";
import { lockingRawMaterials, RawMaterialDtoExtend, splittedFetchData } from "./rawmaterials-list.page";
import { NeqHasTableComponent } from "@sharedcommon/components/table/neq-has-table.component";
import { ValidationService } from "@sharedcommon/services/validation.service";
import { TranslateService } from "@ngx-translate/core";
import { NeqSelectAutocompleteComponent } from "@sharedcommon/components/select-autocomplete/neq-select-autocomplete.component";
import { PrimengTableService } from "@sharedcommon/components/primeng-table/primeng-table.service";
import { lastValueFrom, Subject, takeUntil } from "rxjs";
import { Rights } from "@sharedcommon/util/rights.util";
import { EntityFilterDto, SubEntityServiceClient } from "@sharedcommon/rest/identity.restservice";
import { HeaderService } from "@sharedcommon/services/header.service";
import { MultiEditError } from "@sharedcommon/model/multi-edit-error.model";
import { Constants } from "@sharedcommon/util/constants.util";
import { CalculationStatus } from "@sharedcommon/model/calculation-status.model";
import { NeqTableComponent } from "@sharedcommon/components/table/neq-table.component";
import { NeqDialogService } from "@sharedcommon/services/dialog.service";
import { ToastService } from "@sharedcommon/services/toast.service";
import { JobResponseStatus } from "@sharedcommon/rest/data-custom.restservice";

@Component({
    templateUrl: './rawmaterials-multi-edit.page.html'
})
export class NeqRawmaterialsMultiEditPage extends NeqHasTableComponent<RawMaterialDto> implements OnInit, AfterViewInit, OnDestroy {

    /**
     * Base column of the prime ng table
     */
    private readonly baseCols: PrimengTableCols[] = [
        {
            field: 'calculationStatus',
            header: 'label.user.rawmaterial.calculation-status',
            iconHeaderClassName: 'fas fa-calculator',
            type: 'calculationIcon',
            sortable: false,
            filterable: false,
            position: 'left',
        },
        {
            field: 'code',
            header: 'label.common.code',
            type: 'input-text',
            sortable: false,
            isRawMaterialEditColumn: true,
            isDeletable: false,
            canBeMassEdit: true
        },
        {
            field: 'label',
            header: 'label.common.label',
            type: 'input-text',
            sortable: false,
            isRawMaterialEditColumn: true,
            isDeletable: false,
            canBeMassEdit: true
        }
    ];

    /**
     * Base addable column
     */
    private readonly baseAddableCols: PrimengTableCols[] = [
        {
            field: 'notes',
            header: 'label.common.notes',
            type: 'input-textarea',
            sortable: false,
            isRawMaterialEditColumn: true,
            isDeletable: true,
            canBeMassEdit: true
        },
        {
            field: 'entityLabel',
            header: 'label.common.entity',
            type: 'select',
            sortable: false,
            isRawMaterialEditColumn: true,
            isDeletable: true,
            canBeMassEdit: true
        }
    ];

    /**
     *
     */
    private readonly referenceColumn: PrimengTableCols = {
        field: 'referenceLabel',
        header: 'label.common.reference',
        sortable: false,
        type: 'select',
        isRawMaterialEditColumn: true,
        isDeletable: true,
        canBeMassEdit: true
    };

    private rightReference:any = null;
    private lastRightReference:string = null;
    private readonly canBeInit:boolean = false;
    private initFinished:boolean = false;
    private hasRightError:boolean = false;
    private readonly editValueNutrientRight = [ Rights.U_MP_MASS_EDIT_VALUE ];
    private readonly refRightReadRight = [ Rights.U_REF_RIGHT_READ ];
    private readonly rawMaterialsId: string[];
    private readonly hasRightEditValue: boolean = false;
    private readonly hasRightRefRightRead: boolean = false;
    private canLoadTable: boolean = false;
    private hasNutrientToSave: boolean = false;

    /**
     * Select auto complete element
     */
    @ViewChild('select') valuesSelect: NeqSelectAutocompleteComponent;

    /**
     * Table element
     */
    @ViewChild(NeqTableComponent) table: NeqTableComponent<any>;

    cols:PrimengTableCols[] = this.baseCols;
    selectedColumnHeader:string = undefined;
    destroy$ = new Subject();
    eventDataChecked: Subject<void>;
    isLoading:boolean;
    rawMaterialsNutrientsMap:[string, RawMaterialNutrientDto[]] = null;
    hasBlockedError: boolean = false;

    // Initial data
    initalRawMaterialsData:RawMaterialDtoExtend[] = null;
    initialRawMaterialsNutrientsData:any[] = null;

    constructor(private readonly rawMaterialsMutiEditService: RawMaterialsMultiEditService,
        private readonly router: Router,
        private readonly entityService: EntityServiceClient,
        private readonly rawMaterialService: RawMaterialService,
        private readonly userService: UserService,
        private readonly translateService: TranslateService,
        private readonly primengTableService: PrimengTableService,
        private readonly subEntityService: SubEntityServiceClient,
        private readonly headerService: HeaderService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly referenceRightService: SubReferenceRightServiceClient,
        private readonly dialogService: NeqDialogService,
        private readonly toastService: ToastService,
        validationService: ValidationService
    ){
        super(validationService);

        this.eventDataChecked = new Subject<void>();

        // Get selected raw materials from services
        this.rawMaterialsId = this.rawMaterialsMutiEditService.rawMaterialsId;

        this.hasRightEditValue = this.userService.hasRights(this.editValueNutrientRight);
        this.hasRightRefRightRead = this.userService.hasRights(this.refRightReadRight);

        if (this.rawMaterialsId == undefined || this.rawMaterialsId.length < 1) {
            this.router.navigate(['/app/rawmaterials']);
        } else {
            this.canBeInit = true;
        }
    }

    async ngOnInit(): Promise<void> {
        if (this.canBeInit) {
            this.isLoading = true;
            // Set header
            this.headerService.setHeaderValues({
                strongLabel: this.rawMaterialsId!=null ?'' + this.rawMaterialsId.length : '0',
                basicLabel: this.translateService.instant('label.common.rawmaterials'),
                showGoBack: true,
                redirectionRoute: this.activatedRoute.parent.parent.snapshot
            });

            // Save inital data
            const rawMatFilter = new RawMaterialFilterDto();
            rawMatFilter.ids = this.rawMaterialsId;
            rawMatFilter.page = Constants.ALL_PAGE;

            const res = await splittedFetchData(rawMatFilter, this.rawMaterialsId, this.rawMaterialService, this.userService.getEntity());
            this.initalRawMaterialsData = res.data as RawMaterialDtoExtend[];
            this.canLoadTable = true;
            this.table.fireRefresh();

            // Get all entity available for the current entity
            const entityFilter = new EntityFilterDto();
            entityFilter.allowedFor = this.userService.getEntityDto().id;
            entityFilter.page = Constants.ALL_PAGE;

            // Set to options
            this.subEntityService.fetch(entityFilter).subscribe(response => {
                this.baseAddableCols.find(c => c.field == 'entityLabel').options = response.data;
            });


            // If has right for reference and nutrient modification
            if (this.hasRightEditValue) {
                // Add reference
                this.baseAddableCols.push(this.referenceColumn);

                // Get all Reference
                const referenceFilter = new ReferenceFilterDto();
                referenceFilter.page = Constants.ALL_PAGE;

                // Set to option
                this.entityService.referencesFetch(this.userService.getEntity(), referenceFilter).subscribe(response => {
                    this.baseAddableCols.find(c => c.field == 'referenceLabel').options = response.data;
                });

                // Init nutrient
                await this.refreshNutrientData()

                // Refresh table
                this.valuesSelect.reset();
            }

            this.userService.getJobResult(Constants.JOB_TYPE_MULTI_SAVE).subscribe(value => {
                if (this.initFinished) {
                    this.saveFinished(value.status);
                }
            });

            this.initFinished = true;
            this.isLoading = false;
        }
    }

    ngAfterViewInit() {
        // Subscribe to the event that broadcast the deletion of a dynamic column
        this.primengTableService.deleteColumnEvent$.pipe(takeUntil(this.destroy$)).subscribe(columnField => {
            if (columnField && this.initFinished)
                this.removeColumn(columnField, false, true);
        });

        // Subscribe to the event that broadcast raw mat or nutrient change
        this.primengTableService.changeDataEvent$.pipe(takeUntil(this.destroy$)).subscribe(editedRowData => {
            if (editedRowData && this.initFinished) {
                if (editedRowData !== 'nutrient')
                    this.checkRawMaterialsCoherence(editedRowData);
                this.updateStatus();
            }
        });
    }

    async ngOnDestroy(): Promise<void> {
        // Remove lock
        if (this.rawMaterialsId != undefined && this.rawMaterialsId.length > 1) {
            this.isLoading = true;
            await Promise.all(lockingRawMaterials(this.rawMaterialsId, false, this.rawMaterialService, this.userService.getEntity()));
            this.isLoading = false;
        }
        // Set erros to null
        this.rawMaterialsMutiEditService.multiEditErrors = null;

        // Destroy table (error with event else)
        this.destroy$.next(false);
        this.destroy$.complete();
    }

    refreshTable = async (request: NeqTableRequest) => {
        const neqTableData = new NeqTableData<RawMaterialDtoExtend>();
        if (this.canLoadTable) {
            // Display data on table only when init data is load (error else)
            const results = await this.fetchData(request);

            if (results) {
                neqTableData.results = results.data as RawMaterialDtoExtend[];
                neqTableData.totalElements = results.total;
                neqTableData.pageIndex = request.pageIndex;
                neqTableData.paginate = true;
            }
        }
        return neqTableData;
    }

    fetchColumn = (searchTerm, _page) => {
        return Promise.resolve(this.getFilterdColumn(searchTerm));
    };

    changeSelectedColumn(event: string) {
        this.selectedColumnHeader = event;
    }

    addColumn() {
        const selectedColumn = this.baseAddableCols.find(c => this.translateService.instant(c.header) == this.selectedColumnHeader)

        if (selectedColumn && !this.cols.includes(selectedColumn))
            this.cols.push(selectedColumn);

        this.valuesSelect.reset();
        this.selectedColumnHeader = undefined;
    }

    /**
     * Check if table has change
     * @returns true if has change
     */
    hasChange() {
        let res = false;

        // Check if init is finished
        if (this.initFinished) {
            let rmToSave = this.getRawMatToSave();

            if (this.hasRightEditValue) {
                let nutToSave = this.getNutrientToSave();
                res = rmToSave.length > 0 || nutToSave.length > 0;
            } else {
                res = rmToSave.length > 0;
            }

            // Set dirty for confirmation message on exit
            this.validationService.dirty = res;
        }
        return res;
    }

    save() {
        this.isLoading = true;

        // Get all raw material to save
        let rmToSave = new RawMaterialSaveDto();
        rmToSave.rawMaterialDtos = this.getRawMatToSave();
        rmToSave.rawMaterialNutrientSaveDtos = this.getNutrientToSave();

        this.hasNutrientToSave = rmToSave.rawMaterialNutrientSaveDtos.length > 0;

        // Save they raw mat
        if (rmToSave.rawMaterialDtos.length > 0 || this.hasNutrientToSave) {
            this.rawMaterialService.rawMaterialsMultipleSaveBatchCreate(
                this.userService.getEntity(),
                rmToSave
            ).subscribe((response) => {
                this.userService.addJob(response, Constants.JOB_TYPE_MULTI_SAVE);
                this.toastService.toast(this.translateService.instant('label.user.multi_edit_save.launched'));
            });
        }
    }

    private async saveFinished(status?: JobResponseStatus) {
        if (status == 'OK') {
            // Update initialData with the new value
            for (let rawMat of this.table.data.results) {
                let initialData = this.initalRawMaterialsData.find(rm => rm.id == rawMat.id);

                if (initialData)
                    this.initalRawMaterialsData[this.initalRawMaterialsData.indexOf(initialData)] = rawMat as RawMaterialDtoExtend;
            }

            if (this.hasNutrientToSave) {
                // Refresh nutrient data after save
                await this.refreshNutrientData();
            }

            // Refresh the table
            this.table.fireRefresh();

            this.toastService.toast(this.translateService.instant('label.user.multi_edit_save.result.ok'));
        } else if (status == 'FAILED') {
            this.toastService.toast(this.translateService.instant('label.user.multi_edit_save.result.failed'));
        }
        this.isLoading = false;
    }

    /**
     * Remove a column of the table
     * @param columnField  column name
     */
    private removeColumn(columnField: string, removeFromSearchBar: boolean, refreshSearchBar: boolean) {
        const column = this.baseAddableCols.find(c => c.field == columnField);

        if (column && this.cols.includes(column))
            this.cols.splice(this.cols.indexOf(column), 1);

        if (removeFromSearchBar)
            this.baseAddableCols.splice(this.baseAddableCols.indexOf(column), 1);

        if (refreshSearchBar)
            this.valuesSelect.reset();
    }

    /**
     * Get the filterd column by name
     * @param columnName the column name search
     * @returns the result
     */
    private getFilterdColumn(columnName: string) {
        const notAddedColumn = this.baseAddableCols.filter(c => !this.cols.includes(c));
        const column = notAddedColumn.map(r => {return this.translateService.instant(r.header)});
        return column.filter(c => c.includes(columnName));
    }

    private fetchData(request: NeqTableRequest) {
        // Get data for rawmaterials
        const filter = new RawMaterialFilterDto();
        filter.ids = this.rawMaterialsId;

        filter.page = request.pageIndex;
        filter.count = request.nbElementsParPage;
        filter.sort = this.rawMaterialsMutiEditService.currentSort;

        return splittedFetchData(filter, this.rawMaterialsId, this.rawMaterialService, this.userService.getEntity());
    }

    /**
     * Get the raw materials list of raw materials to save (only if init is finish)
     * @returns the raw materials list
     */
    private getRawMatToSave() {
        let rmToSave = [];

        if (this.initFinished) {
            for (let rm of this.table.data.results) {
                // Get the initial data
                let initialData = this.initalRawMaterialsData.find(r => rm.id === r.id);

                // Check modification
                if (rm.code != initialData.code
                    || rm.label != initialData.label
                    || (rm.notes != initialData.notes)
                    || (rm.entity != null && rm.entity.identifier != initialData.entity.identifier)
                    || rm.referenceId != initialData.referenceId
                    || rm.calculationStatus != initialData.calculationStatus)
                    rmToSave.push(rm);
            }
        }
        return rmToSave;
    }

    /**
     * Get the nutrient list of nutrient to save (only if init is finish)
     * @returns the nutrient list
     */
    private getNutrientToSave() {
        let nutToSave: RawMaterialNutrientSaveDto[] = [];
        if (this.initFinished && this.hasRightEditValue) {
            for (let id of this.rawMaterialsId) {
                for (let nutrient of this.rawMaterialsNutrientsMap[id]) {
                    // Get the initial data
                    let initialData = this.initialRawMaterialsNutrientsData.find(d => d.rmId == id && d.code == nutrient.nutrientCode);

                    // Check modification
                    if (initialData.value != nutrient.value) {
                        let rawMatNutSave = new RawMaterialNutrientSaveDto();
                        rawMatNutSave.rawMaterialId = id;
                        rawMatNutSave.nutrientCode = nutrient.nutrientCode;
                        rawMatNutSave.value = nutrient.value;

                        nutToSave.push(rawMatNutSave);
                    }
                }
            }
        }
        return nutToSave;
    }

    /**
     * Launch every data change to check error
     */
    private async checkRawMaterialsCoherence(editedRowData: any) {
        this.isLoading = true;
        this.hasBlockedError = false;
        let multiEditError: MultiEditError[] = this.rawMaterialsMutiEditService.multiEditErrors;

        // check if initialized
        if (!multiEditError || multiEditError === undefined) {
            // Initialize
            multiEditError = [];
            for (let rawMat of this.table.data.results) {
                let error = new MultiEditError();
                error.rawMatId = rawMat.id;
                multiEditError.push(error);
            };
        }

        // Sort list by reference only in the function to reduce request number
        const rawMatSortByRefId = this.table.data.results.slice();
        rawMatSortByRefId.sort((a, b) => a.referenceId.localeCompare(b.referenceId));

        // Check all raw materials
        for (let rawMat of rawMatSortByRefId) {
            // Find error
            let error = multiEditError.find(r => r.rawMatId == rawMat.id);
            let isNew = false;

            if (error == undefined) {
                isNew = true;
                error = new MultiEditError();
                error.rawMatId = rawMat.id;
            }

            if (rawMat.entity != null) {
                /* PART CODE */
                // Check code/entiy unicity in the table
                error.hasCodeEntitySamePageError = this.table.data.results.filter(r => r.code == rawMat.code && r.entity != null && r.entity.identifier == rawMat.entity.identifier).length > 1;

                // Only if it's the modified rawMaterial or if it's after entity change
                if (((editedRowData.id && editedRowData.id == rawMat.id && rawMat.entity != null) || editedRowData === "forcedEntity") && !this.hasRightError) {
                    // Check code/entiy unicity in all raw materials
                    let filter = new RawMaterialFilterDto();
                    filter.code = editedRowData.code ? editedRowData.code : rawMat.code;
                    filter.textMatchMode = 'STRICT';

                    const resp = await lastValueFrom(this.rawMaterialService.fetch(rawMat.entity.identifier, filter));

                    if (resp === undefined) {
                        this.hasRightError = true;
                        this.dialogService.showErrorSimpleOneMessage(this.translateService.instant('error.common.rawmaterial.right.verification'));
                    } else {
                        error.hasCodeEntityDatabaseError = (resp.data.length == 1 && resp.data[0].entity.identifier === (editedRowData.entity ? editedRowData.entity.identifier : rawMat.entity.identifier) && resp.data[0].id !== (editedRowData.id ? editedRowData.id : rawMat.id)) || (resp.data.length > 1);
                    }
                }

                // Only if it's the modified rawMaterial or if it's after reference change
                if (((editedRowData.id && editedRowData.id == rawMat.id && rawMat.referenceId != null && rawMat.entity != null) || editedRowData === "forcedReference" || editedRowData === "forcedEntity") && this.hasRightRefRightRead) {
                    // Check if reference has right for entity
                    let filter = new ReferenceFilterDto();
                    filter.page = -1;

                    if (this.lastRightReference !== rawMat.referenceId) {
                        this.rightReference = await lastValueFrom(this.referenceRightService.fetch(rawMat.referenceId, new EntityRightFilterDto()));
                        this.lastRightReference = rawMat.referenceId;
                    }
                    error.hasReferenceError = this.rightReference.data.find(r => r.entity.identifier == rawMat.entity.identifier && r.hasRight) === undefined;
                }
            }

            // Add error if it's a new error
            if (isNew) {
                multiEditError.push(error);
            }

            // Check if has a blocked error
            if (error.hasCodeEntityError() || rawMat.referenceId == null || rawMat.entity == null) {
                this.hasBlockedError = true;
            }
        };

        // Save errors result
        this.rawMaterialsMutiEditService.multiEditErrors = multiEditError;
        // Send event
        this.eventDataChecked.next();

        this.isLoading = false;
    }

    /**
     * Update the calculation status of the raw materials
     */
    private updateStatus(){
        for (let rawMat of this.table.data.results) {
            // Update stauts
            let initialData = this.initalRawMaterialsData.find(r => rawMat.id === r.id);
            if (initialData) {
                if (initialData.referenceId != rawMat.referenceId || (this.hasRightEditValue && this.hasNutrientValueChangeForRm(rawMat.id))) {
                    rawMat.calculationStatus = CalculationStatus.BlockBeforeCalc;
                } else {
                    rawMat.calculationStatus = initialData.calculationStatus;
                }
            }
        }
    }

    /**
     * Check if the raw materials has a nutrient value change
     * @param rmId the raw materials id
     * @returns true if has a nutrient value change
     */
    private hasNutrientValueChangeForRm(rmId: string) {
        for (let nutrient of this.rawMaterialsNutrientsMap[rmId])  {
            let initialNutrient = this.initialRawMaterialsNutrientsData.find(d => d.rmId == rmId && d.code == nutrient.nutrientCode);

            if (initialNutrient.value != nutrient.value)
                return true;
        }
        return false;
    }

    /**
     * Refresh nutrient data
     */
    private async refreshNutrientData() {
        const rawMaterialFilter = new RawMaterialFilterDto();
        rawMaterialFilter.ids = this.rawMaterialsId;

        // Get all nutrient for all raw materials on page
        this.rawMaterialsNutrientsMap = await lastValueFrom(this.rawMaterialService.rawMaterialsNutrientsGetAllNutrientsForAllRawMat(this.userService.getEntity(), rawMaterialFilter));

        // Init element
        let allNutrient = [];
        this.initialRawMaterialsNutrientsData = [];

        // For each raw mat
        for (let id of this.rawMaterialsId) {
            // For each nutrient of the raw mat
            for (let nutrient of this.rawMaterialsNutrientsMap[id])  {
                // Add data for save
                this.initialRawMaterialsNutrientsData.push({
                    rmId: id,
                    code: nutrient.nutrientCode,
                    value: nutrient.value
                })

                // If nutrient not on the all nutrient list, add to this list
                if (!allNutrient.some(n => n.code == nutrient.nutrientCode))
                    allNutrient.push({
                        code: nutrient.nutrientCode,
                        label: nutrient.label,
                        description: nutrient.description ? nutrient.description : nutrient.label
                    });
            }
        }

        if (this.initFinished) {
            // Remove nutrient part
            let oldNutrients = this.baseAddableCols.filter(col => col.type == 'input-nutrient' && allNutrient.filter(n => n.code == col.field).length == 0);

            for (let nutrient of oldNutrients) {
                this.removeColumn(nutrient.field, true, false);
            }

            // Add nutrient part
            let newNutrients = allNutrient.filter(n => this.baseAddableCols.filter(col => col.type == 'input-nutrient' && col.field == n.code).length == 0);
            this.addNutrientsToSearchBar(newNutrients);

            // Refresh search bar
            this.valuesSelect.reset();
        } else {
            // For all nutrient on the all nutrient list
            this.addNutrientsToSearchBar(allNutrient);
        }
    }

    private addNutrientsToSearchBar(nutrients: any[]) {
        for (let nutrient of nutrients) {
            this.baseAddableCols.push({
                field: nutrient.code,
                header: nutrient.label,
                isRawMaterialEditColumn: true,
                sortable: false,
                isDeletable: true,
                type: 'input-nutrient',
                canBeMassEdit: true});
        }
    }
}
